import axiosAuth from "@/services/axiosAuth";
import { useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import { DASHBOARD_ADMIN_CLIENT_SHARED_PHOTOS_API } from "./apiRoutes";

interface Props {
  projectId: string;
  queryParams?: Omit<UseQueryOptions, "queryKey">;
}

const getClientPhotos = async (projectId: string): Promise<any> => {
  return await axiosAuth.get(`${DASHBOARD_ADMIN_CLIENT_SHARED_PHOTOS_API(projectId)}`);
};

const useGetClientPhotos = ({ projectId, queryParams }: Props): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["dashboard-pm-client-photos", projectId],
    queryFn: () => getClientPhotos(projectId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    enabled: !!projectId,
    ...queryParams,
  });
};

export default useGetClientPhotos;
